<template>
  <div class="container" style="width: 100vw; height: 100vh;">
    <div style="margin-top: -30px;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army </span>
    <span class="text-black-50 fs-3 fw-bold">(Home)</span>
    </div>
    
    <div class="row justify-content-center" style="padding-top: 70px;padding-left: 5px;padding-right: 5px;">
      <div class="col-md-6">
            <div class="row">
              <div class="col-12 text-start" >
            <span class="fw-bold">Date : </span><span class="text-success">
              {{date}}
            </span><br>
            <span class="fw-bold">Time : </span><span class="text-success">
              {{time}}
            </span><br>
            <span class="fw-bold">Welcome : </span><span class="text-success">{{userObj.user_code+', '+userObj.first_name_en+' '+userObj.surname_en}}</span><br><br>
            <div class="row">
              <div class="col-6 text-end">
                <button @click="goToTestSpeed();" type="button" class="btn btn-light" style="min-width:145px;min-height: 100px;border: 1px black solid;">
                  <i class="fa-solid fa-gauge fa-2x" style="color:purple"></i><br>
                  <span style="font-size: 14px;"><b>Speed Test</b></span>
                </button>
              </div>
              <div class="col-6 text-start">
                <button @click="openPage('survey');" type="button" class="btn btn-light" style="min-width:145px;min-height: 100px;border: 1px black solid;">
                  <i class="fa-solid fa-list-check fa-2x" style="color:red"></i><br>
                  <span style="font-size: 14px;"><b>Survey</b></span>
                </button>
              </div>
            </div>
            <br>
            <div class="row" >
              <div class="col-6 text-end">
                <button @click="openPage('myactivityreport');" type="button" class="btn btn-light" style="min-width:145px;min-height: 100px;border: 1px black solid;">
                  <i class="fa-solid fa-id-card fa-2x color-green"></i><br>
                  <span style="font-size: 12px;"><b>My Activity Report</b></span><br> 
                  <span style="font-size: 10px;"><b>&nbsp;</b></span>
                </button>
              </div>
              <div class="col-6 text-start" v-if="userObj.role_id==2||userObj.role_id==3">
                <button @click="openPage('areaactivityreport');" type="button" class="btn btn-light" style="min-width:145px;min-height: 100px;border: 1px black solid;">
                  <i class="fa-solid fa-newspaper fa-2x color-green"></i><br>
                  <span style="font-size: 12px;"><b>Area Activity Report</b></span><br> 
                  <span style="font-size: 10px;"><b>(Admin only)</b></span>
                </button>
                
              </div>
            </div>
            <br>
            <div class="row" v-if="userObj.role_id==2">
              <div class="col-6 text-end">

                <button @click="openPage('surveygroup');" type="button" class="btn btn-light" style="min-width:145px;min-height: 100px;border: 1px black solid;">
                  <i class="fa fa-layer-group fa-2x"></i><br>
                  <span style="font-size: 12px;"><b>Survey group</b></span><br> 
                    <span style="font-size: 10px;"><b>(Admin only)</b></span>
                </button>
                
              </div>
              <div class="col-6 text-start">
                

                <button @click="openPage('qandcmanagement');" type="button" class="btn btn-light" style="min-width:145px;min-height: 100px;border: 1px black solid;">
                  <i class="fa fa-gear fa-2x"></i><br>
                  <span style="font-size: 12px;"><b>Questions</b></span><br>
                  <span style="font-size: 10px;"><b>(Admin only)</b></span>
                </button>

              </div>
            </div>
            <br>
            <div class="row" v-if="userObj.role_id==2">
              <div class="col-12 text-center">
                <button @click="openPage('userManagement');" type="button" class="btn btn-light" style="min-width:145px;min-height: 100px;border: 1px black solid;">
                  <i class="fa fa-user-pen fa-2x"></i><br> 
                  <span style="font-size: 12px;"><b>Users</b></span><br>
                  <span style="font-size: 10px;"><b>(Admin only)</b></span>
                </button>
              </div>
            </div>
            <br>


            </div>
            </div>

              <div class="mb-3">
                <div class="row">
                  <button type="submit" class="btn btn-danger" @click="logout()">Logout</button>
 
                  </div>
                  </div>
                  </div>
      

      
    </div>

    </div>

    <div id="myModal" class="modal fade" tabindex="-1" role="dialog" ref="myModal">
    <div class="modal-dialog modal-fullscreen" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Test Speed</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeTestSpeed();">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <iframe src="https://meet.mmoney.la/" title="Test Speed" allowfullscreen></iframe> 
        </div>
        <!-- <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div> -->
      </div>
    </div>
  </div>
 
</template>

<script>
//  import { Modal } from 'bootstrap'
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'HomePage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
      myModal:"",
      userObj:JSON.parse(localStorage.getItem("userObj")),
      date:"",
      time:""
    }
  },
  mounted:async function(){
    var vm = this;
    var datetimeAr = vm.userObj.last_login.split("T");
    vm.date = datetimeAr[0];
    vm.time = (datetimeAr[1]).substring(0,8);
    // if(Global.surveyGroup.length==0){
    //   var surveyGroupResult = await vm.getSurveyGroup();
    //     if(surveyGroupResult.status==200&&surveyGroupResult.statusText=="OK"&&surveyGroupResult.data.result){
    //       Global.surveyGroup = surveyGroupResult.data.result;
    //     }
    // }

    // const myModal = this.$refs.myModal;
    // this.myModal = new Modal(document.getElementById('myModal'));
    // this.myModal.show();
    // this.myModal.hide();
  },
  methods: {
    logout:function(){
      var vm = this;
      vm.$swal.fire({
        title: 'Do you want to logout?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes',
        denyButtonText: `No`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.$router.push("/");
        } 
      });
    },
    goToTestSpeed:function(){
      // http://ltcmsisdn.laotel.com:3003/?redirectUrl=http://meet.mmoney.la/?msisdn=
      // http://ltcmsisdn.laotel.com:3003/?redirectUrl=http://speed.laotel.com/?msisdn=
      var userObject = JSON.parse(localStorage.getItem("userObj"));
      var url = Global.testSpeedLink.replace('@', userObject.user_code);
      url = url.replace('#', userObject.phone_number);
      window.open(url, '_blank', 'noreferrer');
      // this.myModal = new Modal(document.getElementById('myModal'));
      // this.myModal.show();
    },
    closeTestSpeed:function(){
      this.myModal.hide();
    },
    openPage: function(page){
      if(page=='qandcmanagement'){
        Global.selectedSurveyGroupName=null;
      }
      this.$router.push("/"+page);
    },
    

   
  },
};
</script>

<style>
/* Add any custom styles here */
</style>
